import BackgroundLayer from "@/components/BackgroundLayer";
import RadioGroup from "@/components/RadioGroup";
import { THRESHOLD_LABELS } from "@/data/exhaleData";
import { ListenButton } from "@/components/AudioControls";

const EVENT_OPTIONS = [
  { value: "A", label: "Hold. My long-term thesis hasn't changed." },
  { value: "B", label: "Reduce my allocation in risky assets by 10–15%. Get more defensive." },
  { value: "C", label: "Move a meaningful portion to cash or safety assets. Protect what I have." },
  { value: "D", label: "Actually increase my allocation in risky assets. Prices are lower now." },
  { value: "E", label: "My advisor would have a recommendation for this." },
];

export default function MarketEvent2({ sessionData, updateSession, onNext, onBack, stageIndex }) {
  const thresholdDisplay = THRESHOLD_LABELS[sessionData.threshold] || sessionData.threshold;
  return (
    <div className="page-wrapper" data-testid="market-event2-page">
      <BackgroundLayer image="/images/page4_bg_event2.jpg" />
      <div className="content-layer" style={{ minHeight: "100vh", minHeight: "100dvh" }}>
        <div className="page-content" style={{ paddingTop: 60, paddingBottom: 80 }}>
          <div className="section-label animate-in" style={{ marginBottom: 12 }}>02: The Market Moves</div>
          <div className="animate-in animate-in-d1" style={{ marginBottom: 20 }}>
            <ListenButton stageIndex={stageIndex} />
          </div>

          <div className="section-text-block">
            <h2 className="section-heading animate-in animate-in-d1" style={{ marginBottom: 20 }}>
              Event 2 — October 2008:
            </h2>
            <p className="standout-line animate-in animate-in-d2" style={{ marginBottom: 4 }}>
              The month the S&P 500 falls -16.9%.
            </p>
            <p className="body-text animate-in animate-in-d2">
              In the headlines,
            </p>
            <p className="body-text animate-in animate-in-d3">
              AIG is bailed out. Washington Mutual collapses. Congress rejects the first bailout bill.
            </p>
            <p className="standout-line animate-in animate-in-d3">
              Your portfolio is now down -14.0% from where you started.
            </p>
            <p className="animate-in animate-in-d4" style={{ color: "var(--accent-teal)", opacity: 0.7, fontSize: "0.95rem", marginTop: 16, marginBottom: 24 }}>
              Your stated threshold was {thresholdDisplay}
            </p>

            <p className="standout-line animate-in animate-in-d5" style={{ marginBottom: 12 }}>
              What do you do now?
            </p>
          </div>

          <div className="animate-in animate-in-d6">
            <RadioGroup
              name="e2"
              options={EVENT_OPTIONS}
              selected={sessionData.e2}
              onSelect={(v) => updateSession("e2", v)}
            />
          </div>

          <div className="nav-buttons animate-in animate-in-d7">
            <button className="nav-back" onClick={onBack} data-testid="back-btn">Back</button>
            <button
              className="cta-pill"
              onClick={onNext}
              disabled={!sessionData.e2}
              data-testid="next-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
